import type { IRespiAllerQuestionnaireStatusCustomControlData } from '@common/validation/customControls/allergology/respiAllerQuestionnaireStatusSchema';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '../../customControlRegistry';

CustomControlRegistry.instance.register<IRespiAllerQuestionnaireStatusCustomControlData>({
    code: CustomControlCode.RespiAllerQuestionnaireStatus,
    version: 1,
});
